module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Big_Text.c12f116c.svg";